import {Button, Col, Row} from "react-bootstrap";
import React from "react";
import * as PropTypes from "prop-types";

export function SurveySectionFooter(props) {
	const { onSaveAndFinish, editMode, isLastSection, isValid } = props;
	return <Row>
		<Col xs={12}>
			{editMode && isLastSection && (
				<Button onClick={onSaveAndFinish} variant="primary" className="float-right" disabled={!isValid}>
					Save and Finish
				</Button>
			)}
		</Col>
	</Row>;
}

SurveySectionFooter.propTypes = {
	editMode: PropTypes.any,
	isLastSection: PropTypes.bool,
	onSaveAndFinish: PropTypes.any,
	isValid: PropTypes.any,
};
